import { Component, OnInit, HostListener } from '@angular/core';
import { AuthService } from 'src/shared/services/REST-API/rest.service';
import { SafeUrl } from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-video-section',
  templateUrl: './video-section.component.html',
  styleUrls: ['./video-section.component.css']
})
export class VideoSectionComponent implements OnInit {
  slideGridNumber = 0;
  videoUrlList;
  lenghtOfvideoUrlList;
  screenWidth;
  url = 'https://apis.google.com/js/platform.js';

  constructor(private authApi: AuthService,
    private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.screenWidth = window.innerWidth;
    this.authApi.getYoutubeLinks().subscribe((data) => {
      this.videoUrlList = data;
      this.lenghtOfvideoUrlList = this.videoUrlList.length;
      this.videoUrlList = this.videoUrlList.map(element => {
        let url = this.sanitizer.bypassSecurityTrustResourceUrl(element.url)
        return { ...element, url }
      });
    })
    this.loadScript()
  }

  public loadScript() {
    let node = document.createElement('script');
    node.src = this.url;
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  showCard(i) {
    if (this.screenWidth > 425) {
      if (Math.floor(i / 3) == this.slideGridNumber) {
        return { 'toShow': false }
      } else {
        return { 'toShow': true }
      }

    } else {
      if (i == this.slideGridNumber) {
        return { 'toShow': false }
      } else {
        return { 'toShow': true }
      }
    }

  }
  scrollRight() {
    --this.slideGridNumber;
  }
  scrollLeft() {
    ++this.slideGridNumber;
  }
  showRightArrow() {
    if (this.screenWidth < 425) {
      if (this.slideGridNumber == this.lenghtOfvideoUrlList - 1) {
        return false
      } else {
        return true
      }
    } else {
      if (this.slideGridNumber == Math.ceil(this.lenghtOfvideoUrlList / 3) - 1) {
        return false
      } else {
        return true
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenWidth = window.innerWidth;
  }


}
